import React, { useEffect, useState } from "react";
import {
  ProjectHighlightsItem,
  ProjectHighlightsProps,
} from "../../../interfaces/projects";
import { transformCloudinaryImg } from "../../../services/utils";
import SlideInDown from "../../Animations/slideInDown";
import SlideInLeft from "../../Animations/slideInLeft";
import Width from "../../Animations/width";
import "./projectsHighlights.scss";

const ProjectsHighlights: React.FC<ProjectHighlightsProps> = ({
  items,
  colors,
}) => {
  const [highlights, setHighlights] = useState<ProjectHighlightsItem[]>([]);
  const [sliderPos, setSliderPos] = useState<any>({});

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const { clientWidth } = document.documentElement;

      setHighlights(
        items.map((item: ProjectHighlightsItem) => ({
          ...item,
          img: transformCloudinaryImg(
            item.img,
            clientWidth <= 768
              ? "c_scale,f_auto,h_400,q_70,w_400"
              : "c_scale,f_auto,h_800,q_70,w_800"
          ),
        }))
      );
    }
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (typeof window !== `undefined`) {
        const el = document.getElementById("horizontal-slider-project");
        const width = document.documentElement.clientWidth;

        if (width <= 768 || items.length === 1) return;

        if (window.pageYOffset - el.offsetTop < 0) {
          setSliderPos({
            transform: `translate3d(0vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
                rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`,
          });
          return;
        }

        if (items.length === 2) {
          const delta1 = el.clientWidth / 95;
          const delta2 = el.clientWidth / (200 + el.clientWidth / 80);

          if (
            window.pageYOffset - el.offsetTop >
            el.clientHeight - el.clientHeight / delta2
          ) {
            setSliderPos({
              transform: `translate3d(-200vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
                rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`,
            });
            return;
          }

          setSliderPos({
            transform: `translate3d(${
              (((window.pageYOffset - el.offsetTop) * 2) / el.clientHeight) *
              (-100 + delta1)
            }vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
                rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`,
          });
          return;
        }

        if (items.length === 3) {
          const delta1 = el.clientWidth / 95;
          const delta2 = el.clientWidth / (300 + el.clientWidth / 80);

          if (
            window.pageYOffset - el.offsetTop >
            el.clientHeight - el.clientHeight / delta2
          ) {
            setSliderPos({
              transform: `translate3d(-200vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
                rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`,
            });
            return;
          }

          setSliderPos({
            transform: `translate3d(${
              (((window.pageYOffset - el.offsetTop) * 3) / el.clientHeight) *
              (-100 + delta1)
            }vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
                rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`,
          });
        }
      }
    };
    if (typeof window !== `undefined`) {
      window.addEventListener("scroll", onScroll);
    }

    return () => {
      if (typeof window !== `undefined`) {
        return window.removeEventListener("scroll", onScroll);
      }
    };
  }, []);

  return (
    <section
      id="highlight"
      className={`highlight ${items.length === 1 ? "single-element" : ""} ${
        items.length === 3 ? "three-elements" : ""
      }`}
    >
      <div className="horizontal-slider-project" id="horizontal-slider-project">
        <div className="horizontal-scroll-wrapper">
          <div className="horizontal-scroll" style={sliderPos}>
            {highlights.map((item: ProjectHighlightsItem, i: number) => (
              <div
                className={`horizontal-scroll-inner ${
                  item.sustainableDevelopment
                    ? "desarrollos-sustentables-bg"
                    : ""
                }`}
                key={i}
              >
                {/* <div className="container"> */}
                <div className="item-content flex align-center">
                  <div className="item-img text-right flex-1">
                    <img
                      className="no-select"
                      src={item.img}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <div className="item-text flex-column flex-1">
                    {item.sustainableDevelopment && (
                      <img
                        className="desarrollos-sustentables"
                        src="../desarrollos-sustentables.svg"
                        loading="lazy"
                      />
                    )}
                    <SlideInLeft distance={50} duration={0.6}>
                      <h3
                        className="item-title font-bold"
                        // style={{ color: colors.primary }}
                        dangerouslySetInnerHTML={{
                          __html: item.title,
                        }}
                      />
                    </SlideInLeft>
                    <Width width="100%" widthMobile="100%">
                      <hr
                      // style={{
                      //   borderColor: colors.secondary,
                      //   backgroundColor: colors.secondary,
                      // }}
                      />
                    </Width>
                    <SlideInDown distance={50} duration={0.6}>
                      <p
                        className="item-description font-book"
                        // style={{ color: colors.primary }}
                        dangerouslySetInnerHTML={{
                          __html: item.description,
                        }}
                      />
                    </SlideInDown>

                    {item.airbnb && (
                      <img
                        className="sub-img"
                        src="../airbnb-logo.svg"
                        loading="lazy"
                      />
                    )}
                  </div>
                </div>
              </div>
              //   </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsHighlights;
